import {FormControl} from "@angular/forms";

export class BasicValidators {
    static invalidEmail(control: FormControl) {
        let expression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if ( ! expression.test(control.value) ) {
            return {
                invalidEmail: true
            }
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/validators/basic.validators.ts